import InsuranceVerificationsList from './InsuranceVerificationsList';

export default InsuranceVerificationsList;
